import {
  initialState,
  Actions,
  State,
  NEW_POST,
  NEW_POST_SUCCESS,
  NEW_POST_ERROR,
  RESET_NEW_POST,
} from "../../types/post/new-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_POST:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_POST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_POST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
